import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Orders.scss";

const Orders = () => {
  const [statusFilter, setStatusFilter] = useState("ALL");
  const { data, loading, refetch } = useApi(() => api.getAdminOrders(), []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      // You may need to add this endpoint
      // await api.updateOrderStatus(id, newStatus);
      refetch();
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const orders = data?.orders || [];
  const filteredOrders = statusFilter === "ALL"
    ? orders
    : orders.filter(order => order.status === statusFilter);

  return (
    <div className="admin-orders">
      <div className="orders-header">
        <h2>Orders</h2>
        <div className="filter-buttons">
          <button
            className={statusFilter === "ALL" ? "active" : ""}
            onClick={() => setStatusFilter("ALL")}
          >
            All
          </button>
          <button
            className={statusFilter === "PENDING" ? "active" : ""}
            onClick={() => setStatusFilter("PENDING")}
          >
            Pending
          </button>
          <button
            className={statusFilter === "COMPLETED" ? "active" : ""}
            onClick={() => setStatusFilter("COMPLETED")}
          >
            Completed
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading orders...</div>
      ) : (
        <div className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Order #</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-state">
                    No orders found
                  </td>
                </tr>
              ) : (
                filteredOrders.map((order) => (
                  <tr key={order.id}>
                    <td>{order.orderNumber}</td>
                    <td>{new Date(order.date).toLocaleDateString()}</td>
                    <td>${order.total}</td>
                    <td>
                      <select
                        value={order.status}
                        onChange={(e) => handleStatusChange(order.id, e.target.value)}
                      >
                        <option value="PENDING">Pending</option>
                        <option value="PROCESSING">Processing</option>
                        <option value="COMPLETED">Completed</option>
                        <option value="CANCELLED">Cancelled</option>
                      </select>
                    </td>
                    <td>{order.paymentMethod || "N/A"}</td>
                    <td>
                      <Link to={`/admin/orders/${order.id}`} className="btn-view">
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
